<template>
  <div class="container">
    <div class="row">

      <div class="content main__content col-md-12">
        <div id="login-page" class="login-page guest-forms"><br>
          <div>
            <login-form-block :autologin="true"></login-form-block>
          </div>
        </div>
      </div>

    </div>

    <div style="margin-top: 4rem;">
      <LoginAchievements/>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
// import Component from 'vue-class-component'
import { Component } from 'vue-property-decorator';
import AuthModel from '@/core/auth/AuthModel';
import { AuthResults } from '@/core/auth/Auth';
import GuestFormGroup from '@/components/forms/guest/GuestFormGroup.vue';
import { UserProfile } from '@/models/core/CoreState';
import LoginButton from '@/views/pages/auth/login/LoginButton.vue';
import LoginForm from '@/views/pages/auth/login/LoginForm.vue';
import { RemoteRequestState } from '@/backoffice/components/pages/taxrules/taxrules';
import LoginFormBlock from '@/views/pages/auth/login/LoginFormBlock.vue';
import LoginAchievements from "@/views/pages/main/LoginAchievements.vue";

@Component({
  name: 'login-page',
  components: {
    LoginAchievements,
    LoginFormBlock, LoginForm, LoginButton, GuestFormGroup,
  },
})
export default class LoginPage extends Vue {
  model = new AuthModel()

  submit() {
    (this.$refs.loginForm as any).submit();
  }

  submitOld(): any {
    this.model.errors.clear();
    this.model.submit().then((data: AuthResults) => {
      // if(process.env.NODE_ENV === 'production') {
      //     console.log(data.getModel());
      // }
      this.$store.state.user.login(data.getResponseData()?.profile as UserProfile);
      this.$router.push('index');
    }, (data: AuthResults) => {
      this.model.errors.setErrors(data.getModel()?.errors);
    });
  }

  authing: RemoteRequestState = new RemoteRequestState();

  get busyModel(): boolean {
    return this.authing.isLoading;
  }


  get isDisabled(): boolean {
    return this.busyModel;
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Логин или email": "Username or e-mail",
    "Пароль": "Password",
    "Авторизация": "Authorization",
    "Регистрация": "Registration"
  }
}
</i18n>
